// extracted by mini-css-extract-plugin
module.exports = {"container":"ResetPassword-module__container--2YZrm","root":"ResetPassword-module__root--3V28n Layout-module__form--1UjW6"};